import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a mobile whiteboard: a 1.2 x 0.9 white board (centre at
// 1.2) in a slim steel frame on two matte-black legs with floor feet, plus a
// marker tray and two thin marker strokes so it reads as used.
const BOARD = "#efece6";
const FRAME = "#aab2b8";
const LEG = "#2e2e30";
const MARKER = "#8a9aa8";
const MARKER_DIM = "#b8b2a8";

export const whiteboard = defineModel({
  id: "whiteboard",
  batchId: "modern",
  name: "Whiteboard",
  tags: ["modern", "interior", "furniture", "office", "board", "meeting"],
  summary: "A mobile whiteboard on two legs with a marker tray.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // legs
      { geometry: new THREE.BoxGeometry(0.05, 1.72, 0.05), color: LEG, position: [-0.58, 0.86, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 1.72, 0.05), color: LEG, position: [0.58, 0.86, 0] },
      // floor feet
      { geometry: new THREE.BoxGeometry(0.06, 0.05, 0.5), color: LEG, position: [-0.58, 0.025, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.05, 0.5), color: LEG, position: [0.58, 0.025, 0] },
      // slim steel frame behind the board
      { geometry: new THREE.BoxGeometry(1.26, 0.96, 0.03), color: FRAME, position: [0, 1.2, -0.015] },
      // white board (1.2 x 0.9, centre at 1.2, facing +Z)
      { geometry: new THREE.BoxGeometry(1.2, 0.9, 0.02), color: BOARD, position: [0, 1.2, 0.005] },
      // marker tray
      { geometry: new THREE.BoxGeometry(0.6, 0.03, 0.08), color: FRAME, position: [0, 0.71, 0.04] },
      // two thin marker strokes
      { geometry: new THREE.BoxGeometry(0.55, 0.03, 0.01), color: MARKER, position: [-0.15, 1.42, 0.02], rotation: [0, 0, -0.06] },
      { geometry: new THREE.BoxGeometry(0.4, 0.03, 0.01), color: MARKER_DIM, position: [-0.22, 1.28, 0.02], rotation: [0, 0, 0.04] },
    ];
  },
  animations: [],
});
